/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if (this.parent) {
						this.parent.classList.add('product-recommendations--full');
						if (document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

					//  Initialize Owl Carousel on all sliders
					const sliders = this.querySelectorAll('.plp-product-slider');
					if (sliders.length && typeof jQuery !== 'undefined') {
						sliders.forEach(slider => {
							if (!slider.classList.contains('owl-loaded')) {
								$(slider).owlCarousel({
									items: 1,
									loop: true,
									nav: true,
									dots: true,
									margin: 5,
									navText: [
										'<button class="owl-prev" aria-label="Previous"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 2L4 6L8 10" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
										'<button class="owl-next" aria-label="Next"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 2L8 6L4 10" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
									]
								});
							}
						});
					}
				}

				this.classList.add('product-recommendations--loaded');
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
